(() => {
  const ROOT_SELECTOR = '[data-hr-labs-owned]';
  const INITIALIZED_ATTRIBUTE = 'data-hr-labs-initialized';
  const OPEN_TRIGGER_CLASSES = {
    'bfd89a3c-651a-480f-8343-9aa80804e0a0': 'r-1c9b5bi',
    '4fbacc55-10a2-4b90-a908-3cb708cb46ec': 'r-nihij0',
    'bb799310-e9b0-4c2f-8d54-b94b59300647': 'r-1x0mqhs',
    '18a82563-c414-4641-859e-cbd371fbd372': 'r-123zxp',
    '436135c3-6844-43f0-9148-6d6fb1284877': 'r-1b3rped',
    'da13b554-2a70-4333-9ef3-4e422f67fa5d': 'r-1aeomo4',
  };

  const initializeAccordion = (collapsible) => {
    const trigger = Array.from(collapsible.children).find((child) => (
      child.matches('[role="button"][aria-controls]')
    ));
    if (!trigger) return false;

    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel || !collapsible.contains(panel)) return false;

    const openClass = OPEN_TRIGGER_CLASSES[trigger.dataset.rid];
    const setExpanded = (expanded) => {
      collapsible.dataset.state = expanded ? 'open' : 'closed';
      trigger.setAttribute('aria-expanded', String(expanded));
      panel.dataset.state = expanded ? 'open' : 'closed';
      panel.hidden = !expanded;
      if (openClass) trigger.classList.toggle(openClass, expanded);
    };
    const toggle = () => setExpanded(trigger.getAttribute('aria-expanded') !== 'true');

    setExpanded(trigger.getAttribute('aria-expanded') === 'true' && !panel.hidden);
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
    return true;
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) return;
      const collapsibles = root.querySelectorAll('[data-replo-collapsible="true"]');
      if (collapsibles.length !== 6) {
        console.warn(`[High Rider Labs] Expected 6 reports, found ${collapsibles.length}.`);
      }
      collapsibles.forEach(initializeAccordion);
      root.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
